module.exports = __webpack_public_path__ + "img/map5.0bf88759.png";